import { baseClient, API, authClient } from '../../utils/index';

// Get about
export const fetchAbout = () => {
	//ToDo: add cookies with an object keyed by the cookie names
	return baseClient().get(`${API}/about`);
};
